import noticeRecovery from './noticeRecovery';
import common from './common';

const messages = {
	noticeRecovery,
	common
};

export default messages;